<template>
  <div class="confirm-modal-overlay" role="dialog" aria-modal="true">
    <div class="confirm-modal" ref="modal">
      <p>{{ message }}</p>
      <div class="button-group">
        <button class="confirm-button" @click="$emit('confirm')" aria-label="Confirm removal">
          {{ confirmText }}
        </button>
        <button class="cancel-button" @click="$emit('close')" aria-label="Cancel removal">
          {{ cancelText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmationModal",
  props: {
    message: {
      type: String,
      default: "Are you sure you want to remove this item?"
    },
    confirmText: {
      type: String,
      default: "Yes"
    },
    cancelText: {
      type: String,
      default: "Cancel"
    }
  },
  mounted() {
    // Focus the modal container for accessibility
    this.$refs.modal.focus();
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.$emit('close');
      }
    }
  }
};
</script>

<style scoped>
.confirm-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.confirm-modal {
  background-color: #ffffff;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
  max-width: 420px;
  width: 90%;
  text-align: center;
  outline: none;
  font-size: 1.05rem;
  color: var(--rich-black);
}

.button-group {
  margin-top: 24px;
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

/* Confirm */
.confirm-button {
  background-color: var(--hollywood-cerise);
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;
}

.confirm-button:hover {
  background-color: var(--violet-lush);
}

/* Cancel */
.cancel-button {
  background-color: #e0e0e0;
  color: var(--rich-black);
  padding: 10px 20px;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;
}

.cancel-button:hover {
  background-color: #cccccc;
}

/* Responsive tweak */
@media (max-width: 480px) {
  .confirm-modal {
    padding: 16px;
  }

  .button-group {
    flex-direction: column;
    gap: 10px;
  }

  .confirm-button,
  .cancel-button {
    width: 100%;
  }
}
</style>
